import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function ModalEventPlansComponent({ Close
    , visibility, deliverymode, handleItemSubmit, selectEventTickets, AccessTypes, onInnerBasicFormChange }: any) {
    return (

        <div className="  w-full p-2 bg-white shadow-md rounded-md">
            <h1 className="text-xl font-bold mb-4 text-center">Add Event Plans</h1>
            <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-4 border p-4">

                <InputContainer

                    label="Enable"
                    name="IsEnabled"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsEnabled'
                        )
                    }}
                    type="checkbox"
                    value={selectEventTickets?.IsEnabled}
                />
                <InputContainer
                    label="Title"
                    name="Title"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Title',

                        )
                    }}
                    type="text"
                    value={selectEventTickets?.Title}
                />



                <InputContainer
                    label="Access Types"
                    labelField="Description"
                    list={AccessTypes}
                    onValueChange={(newValue: any) => {
                        const accessTypeValues: any = newValue.map((option: any) => option?.value || '')

                        onInnerBasicFormChange(accessTypeValues, 'AccessTypes');
                    }}

                    type="multiselect"
                    value={selectEventTickets?.AccessTypes}
                    valueField="Description"
                />



                <InputContainer
                    label="Delivery Mode"
                    labelField="Description"
                    list={deliverymode}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'DeliveryMode',
                        );
                    }}
                    optionName="Choose delivery mode"
                    type="select"
                    value={selectEventTickets?.DeliveryMode}
                    valueField="Description"
                />


                <InputContainer
                    label="Visibility"
                    labelField="Description"
                    list={visibility}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Visibility',
                        );
                    }}
                    optionName="Choose Visibility"
                    type="select"
                    value={selectEventTickets?.Visibility}
                    valueField="Description"
                />

                <InputContainer
                    label="Max Participants"
                    name="MaxParticipants"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'MaxParticipants',

                        )
                    }}
                    type="number"
                    value={selectEventTickets?.MaxParticipants}
                />

                <InputContainer
                    label="Location"
                    name="Location"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Location',

                        )
                    }}
                    type="text"
                    value={selectEventTickets?.Location}
                />

                <InputContainer
                    label="Start Date"
                    name="StartDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'StartDateUtc'
                        )
                    }}
                    type="date"
                    value={selectEventTickets?.StartDateUtc}
                />

                <InputContainer
                    label="End Date"
                    name="EndDateUtc"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'EndDateUtc'
                        )
                    }}
                    type="date"
                    value={selectEventTickets?.EndDateUtc}
                />

            </div>
            <h1 className="text-xl font-bold mb-4 text-center">ContentOutlines</h1>
            <div className=" grid md:grid-cols-2 lg:grid-cols-2 gap-4 border p-4">
                <InputContainer
                    label="Session Id"
                    name="SessionId"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'SessionId',

                        )
                    }}
                    type="text"
                    value={selectEventTickets?.SessionId}
                />

                <InputContainer
                    label="Title"
                    name="Title"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'ContentOutlinesTitle',

                        )
                    }}
                    type="text"
                    value={selectEventTickets?.ContentOutlinesTitle}
                />

                <InputContainer
                    label="Type"
                    labelField="Description"
                    list={AccessTypes}
                    onValueChange={(event: any, newValue: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Type',
                        );
                    }}
                    optionName="Choose delivery mode"
                    type="select"
                    value={selectEventTickets?.Type}
                    valueField="Description"
                />

                <InputContainer
                    label="Start Time"
                    name="StartTime"
                    isDateTimePicker
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'StartTime'
                        )
                    }}
                    type="date"
                    value={selectEventTickets?.StartTime}
                />

                <InputContainer
                    label="End Time"
                    name="EndTime"
                    isDateTimePicker
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'EndTime'
                        )
                    }}
                    type="date"
                    value={selectEventTickets?.EndTime}
                />
            </div>

            <div className="flex justify-end mt-6">
                <button
                    onClick={Close}
                    type="button"
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                >
                    Close
                </button>
                <button
                    className="m-2 bg-blue-900 text-white rounded font-medium px-4 py-3"
                    onClick={handleItemSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>

        </div>



    )
}